<template>
    <section class="sticky-bottom" :class="className">
        <div class="sticky-bottom__container">
            <div class="sticky-bottom__container__text">
                <p v-if="infoCase == 1" class="quorum">Trwa sprawdzanie kworum...</p>
                <p v-if="infoCase == 2" class="quorum">Trwa głosowanie w sprawie: {{elemToDispay}}</p>
                <div v-if="infoCase == 3" class="quorum-still w-100">
                    <div class="d-flex flex-column">
                        <div class="d-flex flex-row justify-content-between">
                            <p class="p-break">Trwa przerwa w obradach</p>
                            <p class="p-break"> {{isOvertime ? '+' : ''}} {{getTimes()}}</p>
                        </div>
                        <p>Szacowana godzina wznowienia: {{elemToDispay.split(':', 2).join(':')}}</p>
                    </div>
                    
                </div>
            </div>
        </div>
    </section>
</template>

<script charset="utf-8">
    import { useTimer, useStopwatch } from 'vue-timer-hook';
    export default {
        name: " InfoModal",
        data() {
            return {
                breakTimer: null,
                isOvertime: false,
            };
        },
        props: {
            infoCase: Number,
            elemToDispay: String,
            elemObj: Object
        },
        watch: {
            elemObj: {
                immediate: true,
                deep: true,
                handler(val) {
                    if (this.infoCase !== 3) {
                        return;
                    }

                    let times = this.elemToDispay.split(':');
                    let old_data = new Date();
                    old_data.setHours(times[0], times[1], times[2], 0);

                    let now_data = new Date();

                    if (now_data > old_data) {
                        var seconds = (now_data.getTime() - old_data.getTime()) / 1000;
                        this.isOvertime = true;
                        this.breakTimer = useStopwatch(seconds, true);
                    }
                    else {
                        this.isOvertime = false;
                        const time = new Date(val.startTime)
                        time.setSeconds(time.getSeconds() + parseInt(val.duration) * 60)
                        this.breakTimer = useTimer(time);
                    }
                }
            },
            breakTimer: {
                deep: true,
                handler(val) {
                    if (val.isExpired) {
                        this.isOvertime = true;
                        this.breakTimer = useStopwatch(0, true);
                    }
                }
            }
        },
        components: {
        },
        computed: {
            className(){
                if(this.infoCase == 3) return "break-info"

                return ""
            }
        },
        mounted() {

        },
        methods: {
            getTimes() {
                if (this.breakTimer === null)
                    return '00:00:00';

                var timeTodisplay = `${this.getLeadZero(this.breakTimer.hours + parseInt(this.breakTimer.days)*24)}:${this.getLeadZero(this.breakTimer.minutes)}:${this.getLeadZero(this.breakTimer.seconds)}`;

                return timeTodisplay;
            },
            getLeadZero(number) {
                if (number < 10)
                    return `0${number}`;

                return `${number}`;
            },
        }
    };
</script>

<style lang="scss" scoped>

    .p-break {
        font-size: 2.0em;
        font-weight: bold;
        margin-bottom: 20px;
    }

    .sticky-bottom {
        position: -webkit-fixed;
        position: fixed;
        bottom: 0;
        border-color: red;
        background: radial-gradient( 100% 100% at 0% 0%, #00082c 0%, #004dcc 100% );
        height: 140px;
        left: 0px;
        right: 0px;
        padding: 50px;
        z-index: 20;

        &__container {
            display: flex;
            font-size: 35px;
            line-height: 144%;
            color: white;
            padding: 25px;

            &__text {
                margin: 10px;
                display: unset;
            }
        }
    }

    .break-info {
        .sticky-bottom__container {
            width: 100%;
            .sticky-bottom__container__text{
                width: 100%;
            }
        }
    }

    .quorum {
        color: white;
        animation: pulse 4s infinite;
    }

    .quorum-still {
        color: white;
    }

    @keyframes pulse {
        0% {
            opacity: 0;
        }

        50% {
            opacity: 1;
        }

        100% {
            opacity: 0;
        }
    }
</style>